"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.stateActions = exports.useSetSrcAmount = exports.useSwitchNativeToWrapped = exports.useSetQueryParams = void 0;
var react_1 = require("react");
var __1 = require("..");
var context_1 = require("./context");
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var useHandleLimitPriceQueryParam = function () {
    var setQueryParam = (0, exports.useSetQueryParams)();
    return (0, react_1.useCallback)(function (value, inverted) {
        var newValue = value;
        if ((0, bignumber_js_1.default)(newValue || 0).isZero()) {
            setQueryParam(__1.QUERY_PARAMS.LIMIT_PRICE, undefined);
        }
        if (inverted) {
            newValue = (0, bignumber_js_1.default)(1)
                .div(value || "0")
                .toString();
        }
        setQueryParam(__1.QUERY_PARAMS.LIMIT_PRICE, newValue);
    }, [setQueryParam]);
};
var useSetQueryParams = function () {
    var enableQueryParams = (0, context_1.useTwapContext)().enableQueryParams;
    return (0, react_1.useCallback)(function (name, value) {
        if (!enableQueryParams)
            return;
        (0, __1.setQueryParam)(name, value);
    }, [enableQueryParams]);
};
exports.useSetQueryParams = useSetQueryParams;
var useSwitchNativeToWrapped = function () {
    var _a = (0, context_1.useTwapContext)(), onSrcTokenSelected = _a.onSrcTokenSelected, dappWToken = _a.dappWToken;
    return (0, react_1.useCallback)(function () {
        if (dappWToken) {
            onSrcTokenSelected === null || onSrcTokenSelected === void 0 ? void 0 : onSrcTokenSelected(dappWToken);
        }
    }, [onSrcTokenSelected, dappWToken]);
};
exports.useSwitchNativeToWrapped = useSwitchNativeToWrapped;
// Hook for handling modal close
var useSwapModalActions = function () {
    var _a = (0, context_1.useTwapContext)(), updateState = _a.updateState, state = _a.state;
    var swapState = state.swapState, wrapSuccess = state.wrapSuccess;
    var onClose = (0, react_1.useCallback)(function (closeDalay) {
        updateState({ showConfirmation: false });
        if (swapState === "loading")
            return;
        setTimeout(function () {
            updateState({
                swapSteps: undefined,
                swapState: undefined,
                swapStep: undefined,
                approveSuccess: undefined,
                wrapSuccess: undefined,
                wrapTxHash: undefined,
                unwrapTxHash: undefined,
                approveTxHash: undefined,
                createOrderSuccess: undefined,
                swapData: undefined,
            });
        }, closeDalay || 300);
    }, [updateState, swapState, wrapSuccess]);
    var onOpen = (0, react_1.useCallback)(function () {
        updateState({ showConfirmation: true });
    }, [updateState]);
    return {
        onClose: onClose,
        onOpen: onOpen,
    };
};
// Hook for handling swap reset
var useSwapReset = function () {
    var updateState = (0, context_1.useTwapContext)().updateState;
    return (0, react_1.useCallback)(function () {
        updateState({
            srcAmountUi: "",
            limitPricePercent: undefined,
            customLimitPrice: undefined,
            isCustomLimitPrice: false,
            isInvertedLimitPrice: false,
            customChunks: undefined,
            customFillDelay: __1.defaultCustomFillDelay,
        });
    }, [updateState]);
};
// Hook for setting custom fill delay
var useSetCustomFillDelay = function () {
    var updateState = (0, context_1.useTwapContext)().updateState;
    var setQueryParam = (0, exports.useSetQueryParams)();
    return (0, react_1.useCallback)(function (customFillDelay) {
        var _a;
        setQueryParam(__1.QUERY_PARAMS.TRADE_INTERVAL, !customFillDelay.amount ? undefined : (_a = customFillDelay.amount) === null || _a === void 0 ? void 0 : _a.toString());
        updateState({ customFillDelay: customFillDelay });
    }, [updateState, setQueryParam]);
};
var useSetCustomDuration = function () {
    var updateState = (0, context_1.useTwapContext)().updateState;
    var setQueryParam = (0, exports.useSetQueryParams)();
    return (0, react_1.useCallback)(function (customDuration) {
        var _a;
        setQueryParam(__1.QUERY_PARAMS.MAX_DURATION, !customDuration ? undefined : (_a = customDuration.amount) === null || _a === void 0 ? void 0 : _a.toString());
        updateState({ customDuration: customDuration });
    }, [updateState, setQueryParam]);
};
var useHandleDisclaimer = function () {
    var _a = (0, context_1.useTwapContext)(), updateState = _a.updateState, state = _a.state;
    return (0, react_1.useCallback)(function () {
        updateState({ disclaimerAccepted: !state.disclaimerAccepted });
    }, [updateState, state.disclaimerAccepted]);
};
// Hook for inverting limit price
var useInvertLimit = function () {
    var _a = (0, context_1.useTwapContext)(), state = _a.state, updateState = _a.updateState;
    var handleLimitPriceQueryParam = useHandleLimitPriceQueryParam();
    return (0, react_1.useCallback)(function () {
        handleLimitPriceQueryParam();
        updateState({
            isInvertedLimitPrice: !state.isInvertedLimitPrice,
            customLimitPrice: undefined,
            isCustomLimitPrice: false,
            limitPricePercent: undefined,
        });
    }, [state.isInvertedLimitPrice, updateState, handleLimitPriceQueryParam]);
};
// Hook for handling limit change
var useOnLimitChange = function () {
    var _a = (0, context_1.useTwapContext)(), state = _a.state, updateState = _a.updateState;
    var handleLimitPriceQueryParam = useHandleLimitPriceQueryParam();
    return (0, react_1.useCallback)(function (customLimitPrice, limitPricePercent) {
        handleLimitPriceQueryParam(customLimitPrice, state.isInvertedLimitPrice);
        updateState({
            customLimitPrice: customLimitPrice,
            isCustomLimitPrice: true,
            isMarketOrder: false,
            limitPricePercent: limitPricePercent,
        });
    }, [state.isInvertedLimitPrice, updateState, handleLimitPriceQueryParam]);
};
// Hook for resetting custom limit
var useResetCustomLimit = function () {
    var updateState = (0, context_1.useTwapContext)().updateState;
    var handleLimitPriceQueryParam = useHandleLimitPriceQueryParam();
    return (0, react_1.useCallback)(function () {
        handleLimitPriceQueryParam();
        updateState({
            isCustomLimitPrice: false,
            customLimitPrice: undefined,
            limitPricePercent: undefined,
        });
    }, [updateState, handleLimitPriceQueryParam]);
};
// Hook for resetting limit price
var useResetLimitPrice = function () {
    var updateState = (0, context_1.useTwapContext)().updateState;
    return (0, react_1.useCallback)(function () {
        updateState({
            isCustomLimitPrice: false,
            customLimitPrice: undefined,
            limitPricePercent: undefined,
            isInvertedLimitPrice: false,
        });
    }, [updateState]);
};
// Hook for handling token switch
var useResetLimitAfterTokenSwitch = function () {
    var updateState = (0, context_1.useTwapContext)().updateState;
    var handleLimitPriceQueryParam = useHandleLimitPriceQueryParam();
    return (0, react_1.useCallback)(function () {
        handleLimitPriceQueryParam();
        updateState({
            isInvertedLimitPrice: false,
            limitPricePercent: undefined,
        });
    }, [updateState, handleLimitPriceQueryParam]);
};
// Hook for selecting orders tab
var useSelectOrdersTab = function () {
    var updateState = (0, context_1.useTwapContext)().updateState;
    return (0, react_1.useCallback)(function (value) { return updateState({ selectedOrdersTab: value }); }, [updateState]);
};
// Hook for showing/hiding orders
var useOnTxHash = function () {
    var updateState = (0, context_1.useTwapContext)().updateState;
    var onCreateOrderTxHash = (0, react_1.useCallback)(function (createOrdertxHash) {
        updateState({ createOrdertxHash: createOrdertxHash });
    }, [updateState]);
    var onWrapTxHash = (0, react_1.useCallback)(function (wrapTxHash) {
        updateState({ wrapTxHash: wrapTxHash });
    }, [updateState]);
    var onUnwrapTxHash = (0, react_1.useCallback)(function (unwrapTxHash) {
        updateState({ unwrapTxHash: unwrapTxHash });
    }, [updateState]);
    var onApproveTxHash = (0, react_1.useCallback)(function (approveTxHash) {
        updateState({ approveTxHash: approveTxHash });
    }, [updateState]);
    return {
        onCreateOrderTxHash: onCreateOrderTxHash,
        onWrapTxHash: onWrapTxHash,
        onUnwrapTxHash: onUnwrapTxHash,
        onApproveTxHash: onApproveTxHash,
    };
};
var useUpdateSwapStep = function () {
    var updateState = (0, context_1.useTwapContext)().updateState;
    return (0, react_1.useCallback)(function (swapStep) {
        updateState({ swapStep: swapStep });
    }, [updateState]);
};
var useUpdateSwapState = function () {
    var updateState = (0, context_1.useTwapContext)().updateState;
    return (0, react_1.useCallback)(function (swapState) {
        updateState({ swapState: swapState });
    }, [updateState]);
};
var useSetSrcAmount = function () {
    var updateState = (0, context_1.useTwapContext)().updateState;
    var setQueryParam = (0, exports.useSetQueryParams)();
    return (0, react_1.useCallback)(function (srcAmountUi) {
        setQueryParam(__1.QUERY_PARAMS.INPUT_AMOUNT, !srcAmountUi ? undefined : srcAmountUi);
        if (!srcAmountUi) {
            (0, __1.resetQueryParams)();
        }
        else {
            setQueryParam(__1.QUERY_PARAMS.INPUT_AMOUNT, srcAmountUi);
        }
        updateState({
            srcAmountUi: srcAmountUi,
            customChunks: undefined,
        });
    }, [updateState, setQueryParam]);
};
exports.useSetSrcAmount = useSetSrcAmount;
var useOnLimitMarketSwitch = function () {
    var updateState = (0, context_1.useTwapContext)().updateState;
    return (0, react_1.useCallback)(function (isMarketOrder) {
        updateState({
            isMarketOrder: isMarketOrder,
        });
    }, [updateState]);
};
var useOnOrderCreated = function () {
    var updateState = (0, context_1.useTwapContext)().updateState;
    return (0, react_1.useCallback)(function () {
        updateState({ swapState: "success", createOrderSuccess: true, selectedOrdersTab: 0 });
    }, [updateState]);
};
exports.stateActions = {
    useSwapModalActions: useSwapModalActions,
    useSwapReset: useSwapReset,
    useSetCustomFillDelay: useSetCustomFillDelay,
    useInvertLimit: useInvertLimit,
    useOnLimitChange: useOnLimitChange,
    useResetCustomLimit: useResetCustomLimit,
    useResetLimitPrice: useResetLimitPrice,
    useResetLimitAfterTokenSwitch: useResetLimitAfterTokenSwitch,
    useSelectOrdersTab: useSelectOrdersTab,
    useOnTxHash: useOnTxHash,
    useUpdateSwapStep: useUpdateSwapStep,
    useUpdateSwapState: useUpdateSwapState,
    useSetSrcAmount: exports.useSetSrcAmount,
    useHandleDisclaimer: useHandleDisclaimer,
    useOnLimitMarketSwitch: useOnLimitMarketSwitch,
    useOnOrderCreated: useOnOrderCreated,
    useSetCustomDuration: useSetCustomDuration,
};
